module.exports={domain:"ssis.eu.auth0.com",clientId:"enVTNU1UQigfzQqAwMcPrgQ3Gu3rCATR"};